export default "__VITE_ASSET__CLP7hmQh__"